export const PACKAGE_ACTION_TYPES = {
  SET_PACKAGE_BOOKS: "package/SET_PACKAGE_BOOKS",
  SET_AVAILABLE_BOOKS: "package/SET_AVAILABLE_BOOKS",
  SET_PACKAGE_ERRORS: "package/SET_PACKAGE_ERRORS",
};
